import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

class DecimalField extends React.Component {
  constructor(props) {
    super(props);
    this.decimalSeparator = Monet.I18n.locale.decimalSymbol;
    this.thousandSeparator = Monet.I18n.locale.digitalGrouping;
  }

  isAllowed = ({ floatValue }) => {
    const { min, max } = this.props;
    return !floatValue || (floatValue >= min && floatValue <= max);
  };

  renderFieldContent = ({ id, input, disabled }) => (
    <div className="fieldWrapper">
      <NumberFormat
        id={id}
        name={input.name}
        decimalScale={2}
        thousandSeparator={this.thousandSeparator}
        decimalSeparator={this.decimalSeparator}
        allowLeadingZeros
        autoComplete="off"
        disabled={disabled}
        value={input.value}
        isAllowed={this.isAllowed}
        onValueChange={({ floatValue }) => {
          input.onChange(floatValue || null);
        }}
        onFocus={input.onFocus}
        onBlur={() => {
          input.onBlur();
          input.onChange(input.value);
        }}
      />
      <div className="fieldIcon" />
    </div>
  );

  gridFormatter = ({ label, name }) => ({
    id: name,
    name,
    label,
    type: 'DECIMAL'
  });

  render() {
    return (
      <BaseField
        fieldClassName="decimalField"
        renderFieldContent={this.renderFieldContent}
        gridFormatter={this.gridFormatter}
        {...this.props}
      />
    );
  }
}

DecimalField.propTypes = {
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number
};

DecimalField.defaultProps = {
  disabled: false,
  min: -9999999999999,
  max: 9999999999999
};

export default DecimalField;
